// Money formatting — the v2 API returns amounts in integer cents.
// Keep all currency math in cents; only format at the display boundary.

// formatPrice(cents) -> "$X.XX"
export const formatPrice = (cents) => {
  const value = Number.isFinite(cents) ? cents : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value / 100);
};
